module.exports = __webpack_public_path__ + "img/right-geometry.bc6e16ce.png";